<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <div class="cards assets">
        <div class='card' v-for='asset in assets'>
          <div @click='downloadAssets(asset)'>
            <div 
              class='asset' 
              :style="{
                backgroundImage: 'url('+asset.img+')'}"></div>
            <p>{{asset.name}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
import axios from 'axios';

export default {
  name: "assets",
  data() {
    return {
      assets: [
        {
          name: 'Popshap logos',
          img: 'https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/popshap_logo_tagline.png?alt=media&token=15385d17-ca40-4d4b-a708-3f6f6cd8b62a',
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/Popshap%20Logos.zip?alt=media&token=cdac0b03-0834-4b78-9c70-a9a9f7323180",
        },
        {
          name: 'Catalog / Brochures',
          img: 'https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/brochure_img.png?alt=media&token=ddc68727-5974-4cc3-8ca9-5ddb2e8f8b85',
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/Brochures.zip?alt=media&token=79dcdc74-75cb-4c85-b8f9-034a0dc180fb",
        },
        {
          name: 'COVID Kiosks',
          img: 'https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/covidkiosksnb.png?alt=media&token=f57da76d-8174-464f-bf46-8a67a87d8cc7',
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/COVID-19.zip?alt=media&token=587c0327-2b8a-4df1-81b5-928344598292",
        },
        {
          name: 'Coffee Touch Tables',
          img: 'https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/coffee%20touch%20table.png?alt=media&token=e2b1879d-9c96-458d-9de9-f427c3bcaab9',
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/21.5%20inch%20Coffee%20Table%20Touch.zip?alt=media&token=5abd978f-4221-4cbf-88da-67e7503fbc1a",
        },
        {
          name: 'Childrens Touch Tables',
          img: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/education%20touch%20table1.png?alt=media&token=18b76f94-727d-4d99-affd-437704b8d751",
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/Children's%20touch%20table.zip?alt=media&token=9f8d7c23-f75f-47b9-84df-4728b8b51f27",
        },
        {
          name: 'POS and Restaurant Ordering',
          img: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/5.png?alt=media&token=94415731-5e8b-4064-b612-4158ec695f83",
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/POS%20and%20Restaurant%20ordering.zip?alt=media&token=89b7f847-28eb-43ec-8734-079a8b19fec0",
        },
        {
          name: 'Rotating Kiosks',
          img: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/9.jpg?alt=media&token=1afe3498-91b3-4c76-ac7c-35620682f6b8",
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/Rotate%20KIOSK.zip?alt=media&token=32dadb32-f50b-4d05-a972-4f65e60ce49d",
        },
        {
          name: 'Outdoors Kiosks',
          img: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/outdoor_img.png?alt=media&token=89bdf058-0311-42ae-a580-e8491140f44c",
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/outdoor.zip?alt=media&token=a8878512-80e8-4331-bb7e-8145052225b4",
        },
        {
          name: 'Standing Kiosks',
          img: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/original.png?alt=media&token=e434d19b-c510-4374-8365-ee9c8e040c5f",
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/standing%20kiosk.zip?alt=media&token=9782e7ac-21ae-4566-b886-d410fd1b2d82",
        },
        {
          name: 'Touch Table Kiosks',
          img: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/original1.png?alt=media&token=514fb89d-cb22-4ab6-ab3e-51f5bde2b5b1",
          assets: "https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/touch%20table.zip?alt=media&token=1913db56-7e0c-474b-809a-e87beebe5380",
        },
      ]
    };
  },
  firestore() {
    
  },
  created() {},
  updated() {},
  methods: {
    downloadAssets(asset) {
      window.open(asset.assets, '_blank')
    }
  },
};
</script>

<style lang="scss">
  .cards.assets {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .card {
      width: 250px;
      margin-right: 20px;
      margin-bottom: 20px;
      padding: 0;
      transition: box-shadow .3s;
      @media screen and (max-width: 1200px){
        width: 31%;
        margin-right: 1.5%;
      }
      @media screen and (max-width: 900px){
        width: 48%;
        margin-right: 1.5%;
      }
      @media screen and (max-width: 700px){
        width: 100%;
        margin-right: 0;
      }
      &:hover {
        box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
      }
      cursor: pointer;
      .asset {
        background-color: white;
        background-position: center center;
        background-size: contain;
        height: 200px;
        width: 100%;
        border-bottom: 2px solid #eaeaea;
        background-repeat: no-repeat;
      }
      p {
        margin: 0;
        padding: 10px 20px;
        background: #dff9ff;
      }
    }
  }
</style>
